module.exports = {
      id: "logos:nswgov-inverse-usage",
      viewBox: "0 0 35 38",
      url: "/static/" + "sprites.1e5806fb7235408b9281f0924c9110c8.svg#logos:nswgov-inverse-usage",
      toString: function () {
        return this.url;
      }
    }